import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Cliente } from "@/shared/types/cliente";
import { SimpleClienteFormData } from "../components/simple-cliente-form.schema";

export async function addSimpleCliente(request: SimpleClienteFormData): Promise<Cliente> {
  await sleep(1000);
  const response = await api.post("clientes", request);
  return response.data;
}

export function useAddSimpleClienteMutation(mutationConfig: MutationConfig<Cliente, SimpleClienteFormData> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: addSimpleCliente,
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["clientes"] });
    },
  })
}

export interface AddSimpleClienteMutationProps {
  mutationConfig?: MutationConfig<Cliente, SimpleClienteFormData>
  children?: (mutationResult: MutationResult<Cliente, SimpleClienteFormData>) => ReactNode
}

export function AddSimpleClienteMutation({
  mutationConfig,
  children
}: AddSimpleClienteMutationProps) {
  const mutationResult = useAddSimpleClienteMutation(mutationConfig);
  return children && children(mutationResult);
}
